import { render, staticRenderFns } from "./PlatformStores.vue?vue&type=template&id=5b98b532"
import script from "./PlatformStores.vue?vue&type=script&lang=js"
export * from "./PlatformStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports